import React from 'react';
import { Plus } from 'lucide-react';

export default function AttendanceHeader({ selectedDate, onDateChange, isAdmin, onAdd }) {
  return (
    <div className="flex flex-col md:flex-row md:items-center md:justify-between gap-4">
      <div>
        <h1 className="text-2xl md:text-3xl font-bold text-gray-900">Absensi & Kehadiran</h1>
        <p className="text-gray-500 mt-1">Monitor kehadiran pegawai harian</p>
      </div>
      <div className="flex flex-col sm:flex-row items-stretch sm:items-center gap-3">
        <input
          type="date"
          value={selectedDate}
          onChange={e => onDateChange(e.target.value)}
          className="px-3 py-2 border border-gray-300 rounded-md focus:outline-none focus:ring-2 focus:ring-emerald-500"
        />
        {isAdmin && (
          <button
            onClick={onAdd}
            className="bg-emerald-600 hover:bg-emerald-700 text-white px-4 py-2 rounded-md font-medium flex items-center justify-center"
          >
            <Plus className="w-4 h-4 mr-2" /> Tambah Kehadiran
          </button>
        )}
      </div>
    </div>
  );
}
